import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "url(#a)",
      "fill-rule": "evenodd",
      d: "M2.37 3.519c-.702 1.05-.702 2.513-.702 5.44v2.083c0 2.926 0 4.389.702 5.44.304.455.695.845 1.15 1.15 1.05.701 2.514.701 5.44.701h2.083c2.926 0 4.389 0 5.44-.702a4.2 4.2 0 0 0 1.15-1.15c.702-1.05.702-2.513.702-5.44V8.959c0-2.926 0-4.389-.703-5.44a4.2 4.2 0 0 0-1.15-1.149c-1.05-.702-2.513-.702-5.439-.702H8.96c-2.926 0-4.39 0-5.44.702a4.2 4.2 0 0 0-1.15 1.15M4.8 9.422q4.05-1.764 5.401-2.326c2.57-1.07 3.107-1.256 3.454-1.262a.6.6 0 0 1 .359.108.4.4 0 0 1 .132.251q.027.181.015.365c-.14 1.464-.742 5.016-1.049 6.656-.13.695-.385.926-.633.95-.425.039-.77-.207-1.154-.48l-.033-.023a7 7 0 0 0-.28-.193c-.426-.28-.754-.504-1.083-.728-.302-.206-.605-.411-.984-.661-.786-.519-.457-.836-.017-1.26q.11-.105.217-.215a17 17 0 0 1 .415-.389l.038-.035c.726-.676 2.064-1.921 2.098-2.068.006-.024.012-.116-.042-.163-.054-.049-.135-.033-.192-.019q-.123.028-3.906 2.582-.553.38-1.004.37c-.33-.007-.967-.187-1.44-.34l-.202-.064H4.91c-.48-.152-.832-.263-.797-.544q.03-.25.688-.512",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "a",
        x1: "10.001",
        x2: "10.001",
        y1: "1.667",
        y2: "18.21",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", { "stop-color": "#2AABEE" }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#229ED9"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }